import { useRef } from 'react';
import {
    useDrag, useDrop,
} from 'react-dnd';
import SmoothScrollPlugin from './smoothScrollingHelper';

const plugin = new SmoothScrollPlugin();

/**
 * @param {{
 * onDrag: function,
 * id: string,
 * index: number,
 * render: JSX.Element,
 * classes: string,
 * }} param0
 */
export default function DraggableRow({
    onDrag, id, render, index, classes,
}) {
    const ref = useRef(null);
    const [{ canDrop, isOver }, drop] = useDrop({
        accept: 'ROW',
        collect: (/** @type {{ isOver: () => any; canDrop: () => any; }} */ monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
        /**
         * @param {{groupId: string, index: number}} item
         * @param {any} monitor
         */
        drop(item, monitor) {
            const diff = monitor.getDifferenceFromInitialOffset(); // moving up -> y is negative
            onDrag && onDrag(item.groupId, item.index, id, index, diff.y < 0);
        },
    });

    const [{ isDragging }, drag] = useDrag({
        type: 'ROW',
        item: () => {
            plugin.onDragStart();
            return { groupId: id, index };
        },
        end: () => {
            plugin.onDragEnd();
        },
        collect: (/** @type {{ isDragging: () => any; }} */ monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    const isActive = canDrop && isOver;
    /** @type {import('@material-ui/styles').CSSProperties} */
    const dynamicStyles = {
        opacity: isDragging ? 0.5 : 1,
        background: isActive ? '#DDDDDD33' : undefined,
    };
    drag(drop(ref));
    return (
        <div
            ref={ref}
            key={index}
            className={classes}
            style={dynamicStyles}
        >
            {render}
        </div>
    );
}
